import AppInsights from '../tracking-tool/app-insights';

/**
 * Common Error Boundary function
 * @param err
 * @param info
 * @returns {JSX.Element}
 */
export function ErrorBoundary(err: any, info: any): JSX.Element {
    AppInsights.trackException(
        {
            id: `${Date.now()}`,
            exception: err,
        },
        { info }
    );
    return <h2>We are having an issue...</h2>;
}
